const regexRules = [
  {
    // [,，\s]分隔符
    regex: /^\s*([+-]?\d+\.?\d*)°?(?:\s*[,，\s]\s*)([+-]?\d+\.?\d*)°?\s*$/,
    rawFormat: 'dms',
    lonlatOrder: 'unknown',
    type: 'point'
  },
  {
    regex: /^\s*(\d+\.?\d*°?[EWew])(?:\s*[,，\s]\s*)(\d+\.?\d*°?[NSns])\s*$/,
    rawFormat: 'dms',
    lonlatOrder: 'lonlat',
    type: 'point'
  },
  {
    regex: /^\s*(\d+\.?\d*°?[NSns])(?:\s*[,，\s]\s*)(\d+\.?\d*°?[EWew])\s*$/,
    rawFormat: 'dms',
    lonlatOrder: 'latlon',
    type: 'point'
  },
  {
    regex: /^\s*([+-]?\d+°(?:\d+')?(?:\d+\.?\d*")?)(?:\s*[,，\s]\s*)([+-]?\d+°(?:\d+')?(?:\d+\.?\d*")?)\s*$/,
    rawFormat: 'degree',
    lonlatOrder: 'unknown',
    type: 'point'
  },
  {
    regex: /^\s*(\d+°(?:\d+')?(?:\d+\.?\d*")?[EWew])(?:\s*[,，\s]\s*)(\d+°(?:\d+')?(?:\d+\.?\d*")?[NSns])\s*$/,
    rawFormat: 'degree',
    lonlatOrder: 'lonlat',
    type: 'point'
  },
  {
    regex: /^\s*(\d+°(?:\d+')?(?:\d+\.?\d*")?[NSns])(?:\s*[,，\s]\s*)(\d+°(?:\d+')?(?:\d+\.?\d*")?[EWew])\s*$/,
    rawFormat: 'degree',
    lonlatOrder: 'latlon',
    type: 'point'
  }
];

function dmsLonLatStrToNum(dmsLonLatStr) {
  // dmsLonLatStr格式为：
  // 1. [+-]?141.1[°]?
  // 2. 141.1[°]?[NSEWnsew]
  var num,
    unit = 1,
    numRegex = {
      signReg: /^\s*([+-]?\d+\.?\d*)°?\s*$/,
      ortReg: /^\s*(\d+\.?\d*)°?([NSEWnsew])\s*$/
    };
  var reg, matchResult;
  for (reg in numRegex) {
    matchResult = numRegex[reg].exec(dmsLonLatStr);
    // 匹配，退出循环
    if (matchResult) {
      break;
    }
  }
  // 'signReg', 'ortReg'正则都不匹配, 返回null
  if (!matchResult) {
    return;
  }
  var flag;
  // 2. 141.1[°]?[NSEWnsew]
  if (reg === 'ortReg') {
    flag = matchResult.slice(-1)[0];
    if ('SWsw'.indexOf(flag) !== -1) {
      unit = -1;
    }
  }
  num = parseFloat(matchResult[1]) * unit;
  if (num < -180 || num > 360) {
    return;
  }
  if (reg === 'ortReg' && 'NSns'.indexOf(flag) !== -1) {
    if (num < -90 || num > 90) {
      return;
    }
  }
  return num;
}

function degreeLonLatStrToNum(degreeLonLatStr) {
  // degreeLonLatStr格式为：
  // 1. [+-]?141°[12']?[12"]?
  // 2. 141°[12']?[12"]?[NSEWnsew]
  var num,
    unit = 1,
    degreeRegex = {
      signReg: /^\s*([+-]?)(\d+)°(?:(\d+)')?(?:(\d+\.?\d*)")?\s*$/,
      ortReg: /^\s*(\d+)°(?:(\d+)')?(?:(\d+\.?\d*)")?([NSEWnswe])\s*$/
    };
  var reg, matchResult;
  for (reg in degreeRegex) {
    matchResult = degreeRegex[reg].exec(degreeLonLatStr);
    // 匹配，退出循环
    if (matchResult) {
      break;
    }
  }
  // 'signReg', 'ortReg'正则都不匹配null
  if (!matchResult) {
    return;
  }
  var flag;
  // 1. [+-]?141°[12']?[12"]?
  if (reg === 'signReg') {
    flag = matchResult[1];
    if (flag === '-') {
      unit = -1;
    }
    matchResult = matchResult.slice(2);
  }
  // 2. 141°[12']?[12"]?[NSEWnsew]
  else {
    flag = matchResult.slice(-1)[0];
    if ('SWsw'.indexOf(flag) !== -1) {
      unit = -1;
    }
    matchResult = matchResult.slice(1, -1);
  }
  // 字符串数组转成数值数组
  var degrees = matchResult.map(v => {
    // void 0 = undefined
    return v === void 0 ? 0 : parseFloat(v);
  });
  num = (degrees[0] + degrees[1] / 60 + degrees[2] / 3600) * unit;
  if (num < -180 || num > 360) {
    return;
  }
  if (reg === 'ortReg' && 'NSns'.indexOf(flag) !== -1) {
    if (num < -90 || num > 90) {
      return;
    }
  }
  return num;
}

/*
 * 将浮点数切分为整数和小数部分
 * 1.1 --> [1, 0.1]
 * -1.1 --> [-1, -0.1]
 * */
function floatSplit(number) {
  var integer,
    decimal = number % 1;
  if (number > 0) {
    integer = Math.floor(number);
  } else {
    integer = Math.floor(number) + 1;
  }
  return [integer, decimal];
}

function dmsToDegree(dms) {
  var degree = [];
  var fs = floatSplit(dms);
  degree.push(fs[0]);
  if (fs[1] === 0) return degree;
  var minute = parseFloat((fs[1] * 60).toFixed(6));
  fs = floatSplit(minute);
  degree.push(fs[0]);
  if (fs[1] === 0) return degree;
  var second = parseFloat((fs[1] * 60).toFixed(3));
  degree.push(second);
  return degree;
}

function lonlatRuleParse(rule, str) {
  const matchResult = rule.regex.exec(str);
  // 为null，不匹配
  if (!matchResult) {
    return;
  }
  // 匹配
  const group = rule.type === 'point' ? [1, 2] : [1, 2, 3, 4];
  const lonlat = group.map(v => {
    if (rule.rawFormat === 'dms') {
      return dmsLonLatStrToNum(matchResult[v]);
    }
    return degreeLonLatStrToNum(matchResult[v]);
  });
  if (lonlat.includes(undefined)) {
    return;
  }
  var isAllLon = lonlat.every(v => {
    return v < -90 || v > 90;
  });
  // lonlat数组中所有项在[-90, 90]范围外
  if (isAllLon) {
    return;
  }
  var processedInputs = lonlat.map(v => {
    v = v > 180 ? v - 360 : v;
    var absV = Math.abs(v);
    if (rule.rawFormat === 'dms') {
      return absV;
    } else {
      let rawInputs = '',
        units = ['°', "'", '"'];
      const degrees = dmsToDegree(absV);
      for (var i = 0; i < degrees.length; i++) {
        rawInputs += degrees[i] + units[i];
      }
      return rawInputs;
    }
  });
  var res = {
    // 'point', 'rect'
    type: rule.type,
    // 'lonlat', 'latlon', 'unknown'
    lonlatOrder: rule.lonlatOrder,
    // 'degree', 'dms'
    rawFormat: rule.rawFormat,
    // point: [lat, lon], rect: [lat1, lat2, lon1, lon2]
    values: lonlat,
    processedInputs: processedInputs
  };
  if (rule.lonlatOrder === 'unknown' && rule.type === 'point') {
    var isAllLat = lonlat.every(v => {
      return v >= -90 && v <= 90;
    });
    if (isAllLat) {
      //
    } else if (lonlat[0] >= -90 && lonlat[0] <= 90) {
      res.lonlatOrder = 'latlon';
      lonlat[1] = lonlat[1] > 180 ? lonlat[1] - 360 : lonlat[1];
    } else {
      res.lonlatOrder = 'lonlat';
      lonlat[0] = lonlat[0] > 180 ? lonlat[0] - 360 : lonlat[0];
    }
  }
  return res;
}

export default function parse(keyword) {
  for (let i = 0; i < regexRules.length; i++) {
    const res = lonlatRuleParse(regexRules[i], keyword);
    if (res) {
      return res;
    }
  }
  return null;
}
